module.exports = __webpack_public_path__ + "static/media/2.5e4f33dc.png";